import { BaseDto } from '../base.dto';
import type { FieldConfigurationDto } from '../field-configuration/field-configuration.dto';
import type { MedicalUnitDto } from '../medical-unit.dtos';
import type { UserDto } from '../user.dto';

export class ResponseReviewDto extends BaseDto {
  hasResponseBeenReviewed: boolean;
  responseReviewNote?: string | null;
  responseReviewDate?: string;
  responseReviewedByUser?: UserDto;
  medicalUnit?: MedicalUnitDto;
  patientResponse?: {
    textMessage: string;
  };

  // The following segment is for displaying diagnosis in the condition history panel
  diagnosisId?: string;
  diagnosisGroupIds?: string[];
  fieldConfiguration?: FieldConfigurationDto;
}
